export default "__VITE_ASSET__DrCkdvWK__"